/**
 * Guscio dell'applicazione: barra laterale e area di contenuto.
 *
 * Non c'e' una testata: ente, utenza, tema e uscita stanno nella barra
 * laterale, come nel back-office gemello, e la pagina comincia dal suo titolo.
 *
 * E' anche il punto in cui si carica l'alberatura una volta sola per tutte le
 * pagine protette.
 */

import { Outlet } from "react-router-dom";
import { Assistente } from "../assistente/Assistente";
import { ConfineAssistente } from "../assistente/ConfineAssistente";
import { useAutenticazione } from "../auth/contesto";
import { Bottone } from "../components/primitive";
import { FornitoreAlberatura } from "../dati/FornitoreAlberatura";
import { BarraLaterale } from "./BarraLaterale";

export function Guscio() {
  return (
    <FornitoreAlberatura>
      <div className="guscio">
        <BarraLaterale />
        <div className="contenuto">
          <FasciaImpersonificazione />
          <main className="area">
            <Outlet />
          </main>
        </div>
      </div>
      <ConfineAssistente>
        <Assistente />
      </ConfineAssistente>
    </FornitoreAlberatura>
  );
}

/**
 * Fascia che dichiara l'impersonificazione in corso.
 *
 * Sta nel guscio e non in una pagina perche' deve essere **inevitabile**: un
 * amministratore che si e' messo nei panni di un'altra utenza e lo dimentica
 * crede di agire come se', ed e' il modo piu' facile di fare danni in buona
 * fede. Per questo e' sopra il contenuto, in ogni pagina, e porta con se' la
 * via d'uscita.
 *
 * Dice anche la cosa scomoda: cio' che si scrive da qui risulta dell'utenza
 * impersonificata e non porta traccia di chi ha materialmente agito. Chi opera
 * ha diritto di saperlo mentre lo fa, non dopo.
 */
function FasciaImpersonificazione() {
  const { utente, impersonatoDa, impersonificazioneScadeIl, terminaImpersonificazione } =
    useAutenticazione();
  if (!impersonatoDa || !utente) return null;

  return (
    <div className="fascia-impersonificazione" role="status">
      <div className="fascia-impersonificazione__testo">
        <strong>Stai operando come {utente.nome_utente}</strong> — impersonificazione avviata da{" "}
        {impersonatoDa}
        {impersonificazioneScadeIl ? `, scade il ${impersonificazioneScadeIl}` : ""}. Cio' che
        crei o decidi da qui risultera' di questa utenza, senza traccia della tua.
      </div>
      <Bottone variante="contorno" dimensione="piccolo" onClick={terminaImpersonificazione}>
        Torna alla tua utenza
      </Bottone>
    </div>
  );
}

/** Intestazione standard di pagina: sopratitolo, titolo, sottotitolo, azioni. */
export function IntestazionePagina({
  sopratitolo,
  titolo,
  sottotitolo,
  azioni,
}: {
  sopratitolo?: string;
  titolo: string;
  sottotitolo?: string;
  azioni?: React.ReactNode;
}) {
  return (
    <div className="intestazione-pagina">
      <div>
        {sopratitolo ? <p className="sopratitolo">{sopratitolo}</p> : null}
        <h1 className="titolo-pagina">{titolo}</h1>
        {sottotitolo ? <p className="sottotitolo">{sottotitolo}</p> : null}
      </div>
      {azioni ? <div className="riga">{azioni}</div> : null}
    </div>
  );
}
